<template>
  <col4>
  <v-card
    class="elevation-4"
    :class="{ 'project-card--recent': recent }"
    :data-recent="recent ? 'true' : 'false'"
  >
      <v-card-title class="d-flex align-center flex-wrap">
          <span>{{project.name}}</span>
          <v-chip
            v-if="recent"
            class="ml-2 project-card-recent-chip"
            size="small"
            color="primary"
            variant="tonal"
            density="compact"
            data-testid="project-recent-chip"
          >
            {{ $t('projects.recent') }}
          </v-chip>
      </v-card-title>
      <v-card-subtitle style="min-height: 60px;">
          {{project.description}}
      </v-card-subtitle>
     <v-card-text>
      <row>
        <col6>
          <div
            class="project-card-preview"
            :class="{ 'project-card-preview--blur': sensitiveBlurForFavourite }"
          >
          <v-img v-if="favourite && favourite.id"
            :src="api_path + '/protected/asset/' + favourite.id + '?token=' + token"
            :lazy-src="static_path + '/examples/chital.png'"
            aspect-ratio="1"
            class="grey lighten-2"
          >
            <template v-slot:placeholder>
              <v-row
                class="fill-height ma-0"
                align="center"
                justify="center"
              >
                <v-progress-circular
                  indeterminate
                  color="grey lighten-5"
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>
          </div>
        </col6>
        <col6>
            <div v-for="user in users" :key="user.id" :title="user.first_name">
                <show-gravatar :user="user"></show-gravatar> 
            </div>
        </col6>
      </row>
     </v-card-text>
  </v-card>
    </col4>
</template>

<script>
import Col4 from "@/components/layout/Col4";
import Row from "@/components/layout/Row";
import Col6 from "@/components/layout/Col6";
import ShowGravatar from '@/components/projects/ShowGravatar';
import CurrentUserMixin from '@/mixins/CurrentUserMixin.vue';
import {
  getBlurUnlessMetaFromSettings,
  shouldBlurAssetMeta,
} from '@/utils/sensitiveImageBlur';

export default {
name: "ProjectCard",
  components: {ShowGravatar, Col6, Row, Col4},
  mixins: [CurrentUserMixin],
  props: {
    project: {required: true},
    recent: { type: Boolean, default: false },
  },
  computed: {
    token () {
      return localStorage.token;
    },
    favourite () {
      return this.$store.getters['project/get_favourite'](this.project.id)
    },
    users () {
      return this.$store.getters['project/get_users'](this.project.id)
    },
    api_path () {
      return this.$api_host
    },
    static_path () {
      return this.$api_url
    },
    sensitiveBlurForFavourite() {
      const rel = this.project && this.project.relationships;
      const settings = (rel && rel.sensitive_image_settings) || [];
      const policy = getBlurUnlessMetaFromSettings(settings);
      const exempt = this.is_sensitive_image_blur_exempt_for_project(this.project.id);
      return shouldBlurAssetMeta(this.favourite && this.favourite.meta, policy, exempt);
    },
  }
}
</script>

<style scoped>
.project-card-preview--blur :deep(img) {
  filter: blur(28px);
  transform: scale(1.02);
}
.project-card--recent {
  outline: 2px solid rgba(25, 118, 210, 0.35);
}
.project-card-recent-chip {
  font-size: 0.7rem;
  height: 22px;
}
</style>